import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetTokenQuery } from "src/store/slices/authentication/Token.api";
import { login } from "src/store/slices/authentication/auth.slice";
import { AuthFlowResult } from "./types";

// "auto-login" silently authenticates using the credentials baked into app.config.ts
// (dev/staging only). If that request fails — wrong/missing credentials, backend down —
// this must stop blocking the app rather than spin the splash screen forever: AppInitializer
// treats isFetching:false + no token as "done", and RouteGuard then falls through to the
// normal /login page, exactly as if auto-login had never been attempted.
export default function useAutoLoginFlow(enabled: boolean): AuthFlowResult {
  const { data: token, isFetching, error } = useGetTokenQuery(null, { skip: !enabled });
  const dispatch = useDispatch();
  const [isDispatched, setIsDispatched] = useState(false);

  useEffect(() => {
    if (token) {
      dispatch(login(token));
      setIsDispatched(true);
    }
  }, [token]);

  const isWaitingForDispatch = !!token && !isDispatched;
  return { isFetching: enabled && (isFetching || isWaitingForDispatch), error };
}
